import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "incFace",
  "use": "incFace-usage",
  "viewBox": "0 0 108 108",
  "content": "<symbol viewBox=\"0 0 108 108\" id=\"incFace\"><defs><style>#incFace .cls-1{fill:#edf0f2;}#incFace .cls-2{opacity:0.5;font-size:20px;font-family:AlibabaPuHuiTiB-GBpc-EUC-H, Alibaba PuHuiTi;font-weight:700;}#incFace .cls-3{letter-spacing:-0.04em;}</style></defs><title>资源 1</title><g id=\"incFace_图层_2\" data-name=\"图层 2\"><g id=\"incFace_图层_1-2\" data-name=\"图层 1\"><circle class=\"cls-1\" cx=\"54\" cy=\"54\" r=\"54\" /><text class=\"cls-2\" transform=\"translate(27.22 59.28)\"><tspan class=\"cls-3\">L</tspan><tspan x=\"9.82\" y=\"0\">OGO</tspan></text></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/incFace.svg
// module id = Sct3
// module chunks = 264